<template>
    <div>
      <apexchart style="margin-bottom:30px" v-if ="progres" type="donut" :options="sd.chartOptions" :series="sd.series"></apexchart>
<div v-for="(key,value) in this.$helper.groupByAdet(posts,'st')" :key="key">
          <van-panel :title="value" :status="key+' Adet'"></van-panel>
</div>
          <van-swipe-cell v-for="item in ajanda" :key="item.id">
          <van-panel :title="`Tarih: ${$helper.trtgoster(item.tarih)}`" :desc="item.alias"/>
            <template #right>
              <van-button square type="primary" text="Arşivle" @click="arsiv(item.id)"/>
            </template>
          </van-swipe-cell> 

        <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>

      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>

export default {
  data() {
    return {
       sd:{},
       posts:[],
       progres:false, // piechart için
       donem: this.$request.donem(),
       active:'Home',
       ayar : this.$request.ayar(),
       show:false,
       ajanda:[],
       st:[]
    };
  },
  created (){
          this.$barcodeScanner.init(this.onBarcodeScanned)

     this.yetki()
     
  },
      destroyed () {
      // Remove listener when component is destroyed
      this.$barcodeScanner.destroy()
    },
  methods : {
          onBarcodeScanned (barcode) {
        console.log(barcode)
        // do something...
      },
      // Reset to the last barcode before hitting enter (whatever anything in the input box)
      resetBarcode () {
        let barcode = this.$barcodeScanner.getPreviousCode()
        // do something...
      },
      yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                table = 'servis'
                baslat = true
                this.getPostsAsync(table,baslat)
            }
            else{
              table = 'kayit'
              baslat=true
              this.getPostsAsync(table,baslat)
            }

      },    
    getPostsAsync (table,islem){
      this.show = true;
       this.$request.get("servis/mobilservis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+table)
        .then(res => {
            this.posts = res.results
            this.sd = this.$helper.piechart(this.$helper.groupByAdet(res.results,'sd')),
          
           this.progres = true
            this.ajandagetir()
            
        })
        .catch(err => {this.error.push(err)})
        },
        ajandagetir(){
          console.log(this.sd)
          this.$request.get("servis/ajanda/"+this.ayar.firmaid+"/"+this.ayar.kid)
          .then(res => {
            this.ajanda = res.results.sort((t1,t2) => t1.id > t2.id ? -1 : 1)
            this.show = false;
          })
        },
        arsiv(ids){
          this.show = true;
            let newPost = {
              id : ids,
            }
            this.$request.post("servis/updateAjanda/", newPost)
            .then (() => { this.ajandagetir() })
        },

  }
};
</script>


// WEBPACK FOOTER //
// src/components/main.vue